<template>
	<section class="block-lg">
		<h2 class="headline-lg center">{{ $t('home.mission.ourMission') }}</h2>
		<div class="roadmap">
			<div
				class="roadmap-line"
				ref="line"
			>
        <span
			class="roadmap-line__bg"
			ref="lineBg"
		></span>
			</div>
			<div
				v-for="(mission, index) in missions"
				:class="`roadmap-item--c${index + 1}`"
				class="roadmap-item off"
				:key="mission.body"
				ref="roadmapItems"
			>
				<div class="roadmap-item__col-title">
					<div class="roadmap-item__title">
						<div class="roadmap-item__icon">
							<img
								:src="getMetaGlobOfAssetsSvg[mission.icon].default"
								alt=""
								class="img img--contain"
							>
						</div>
						<p class="body-2">{{ mission.body }}</p>
						<h3 class="headline-1">{{ mission.headline }}</h3>
					</div>
				</div>
				<div class="roadmap-item__col-data">
					<p class="roadmap-item__data body-1">
						{{ mission.text }}
						<a
							v-if="mission.link"
							:href="mission.link"
							class="roadmap-item__icon-link icon-external-link"
						></a>
					</p>
				</div>
			</div>
		</div>

	</section>
</template>

<script>


export default {
	data() {
		return {
			missions: [
				{
					icon: '/assets/images/svg/Verified-user.svg',
					body: 'STEP 1',
					headline: this.$t('home.mission.verification'),
					text: this.$t('home.mission.verificationDesc'),
					link: ''
				},
				{
					icon: '/assets/images/svg/User-recognition.svg',
					body: 'STEP 2',
					headline: this.$t('home.mission.kyc'),
					text: this.$t('home.mission.kycDesc'),
					link: ''
				},
				{
					icon: '/assets/images/svg/Video-conference.svg',
					body: 'STEP 3',
					headline: this.$t('home.mission.doxxing'),
					text: this.$t('home.mission.doxxingDesc'),
					link: ''
				},
			]
		}
	},
	computed: {
		getMetaGlobOfAssetsSvg() {
			return import.meta.glob('/assets/images/svg/*.svg', {eager: true})
		},
		line() {
			return this.$refs.line
		},
		lineBg() {
			return this.$refs.lineBg
		},
		roadmapItems() {
			return this.$refs.roadmapItems
		},
		startPoint() {
			return window.innerHeight * 0.85
		},
		startHeight() {
			return this.lineBg.offsetHeight
		},
	},
	methods: {
		linePos() {
			const currentPos = this.line.getBoundingClientRect().top
			const height = currentPos > this.startPoint
				? this.startHeight
				: Math.max(0, this.startHeight - (this.startPoint - currentPos))
			this.lineBg.style.height = `${height}px`
			this.roadmapItems.forEach(e => {
				if (e.getBoundingClientRect().top < this.startPoint) {
					if (e.classList.contains('off')) e.classList.remove('off')
				} else if (!e.classList.contains('off')) e.classList.add('off')
			})
		},
	},
	mounted() {
		this.linePos()
		document.addEventListener('scroll', this.linePos)
	},
	unmounted() {
		document.removeEventListener('scroll', this.linePos)
	}
}


</script>
